import type { MobxDocument } from '../firestore-mobx/document'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreTeachingPlanAggregation } from '../firestore/TeachingPlanAggregation/schema'
import { emptyTeachingPlanAggregation } from '../firestore/TeachingPlanAggregation/schema'

import type { FirebaseRepository } from './FirebaseRepository'

export class TeachingPlanAggregation extends ObservableModelWithDecorators<FirestoreTeachingPlanAggregation> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptyTeachingPlanAggregation)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptyTeachingPlanAggregation)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreTeachingPlanAggregation>
  ) {
    super(repository, doc)
  }
}
